import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * which skin to use. Standard uses the vista blue and Alert uses the red alert color
  */
  skin: PropTypes.oneOf(['standard', 'alert'])
};
var Count = createComponent({
  displayName: 'Count',
  root: 'span',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-count']);
      var _props$skin = props.skin,
          skin = _props$skin === void 0 ? 'standard' : _props$skin;
      if (skin != 'standard') classNameSet.add("swan-count-skin-".concat(skin));
      return classNameSet;
    }
  }
});
Count.defaultProps = {
  skin: 'standard'
};
export { Count };